import styled from '@emotion/styled'
import { Box } from 'components/layout/primitives/Box'
import { FlexMods, FlexParentBase } from 'components/styles/primitives/modifiers/flex'

/**
 * A good ole Box, given all the super powers of display:flex;
 */
export const FlexBox = styled(Box)`
	${FlexParentBase};
	${FlexMods.Parent};
`
